import { inject, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Uuid } from '@ftr/contracts/type/shared'
import { AppPaths } from '@ftr/routing-paths'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'
import { map, Observable, of, switchMap } from 'rxjs'
import { ExternalUserNavItemsProvider } from './external/external-user-nav-items.provider'
import { InternalUserNavItemsProvider } from './internal/internal-user-nav-items.provider'
import { SideNavGroup, SideNavItem } from './side-nav-item'

export interface SideNavProviderResult {
  navGroups: SideNavGroup[]
  footerItems: SideNavItem[]
}

@Injectable({
  providedIn: 'root',
})
export class CourtsSideNavItemsProvider {
  private readonly internalUserNavItemsProvider = inject(InternalUserNavItemsProvider)
  private readonly externalUserNavItemsProvider = inject(ExternalUserNavItemsProvider)
  private readonly router = inject(Router)
  private readonly store = inject(Store)

  provide(courtSystemId: Uuid | undefined): Observable<SideNavProviderResult> {
    const hasPermissionsInCourtSystem$ = courtSystemId
      ? this.store.select(UserState.getEnabledPermissions).pipe(map(fn => fn(courtSystemId).length > 0))
      : of(false)

    const isPublicRoute = this.router.url?.includes(`/${AppPaths.Request}/`)

    return hasPermissionsInCourtSystem$.pipe(
      switchMap(hasPermissions => {
        if (courtSystemId && hasPermissions && !isPublicRoute) {
          return this.internalUserNavItemsProvider.provide(courtSystemId)
        }
        return this.externalUserNavItemsProvider.provide()
      }),
    )
  }
}
